import { Page } from '@/declarations/models/Page';
import { deepCopy } from '@/utils/object';

/**
 * Returns a copy of the page adjusted to what the backend accepts on save.
 * @param page The page to save
 */
export function preparePageForSave(page: Page): Page {
  const pageCopy = deepCopy(page);

  if (pageCopy.main_category === 'event') {
    // Make sure event_data is present
    pageCopy.event_data = pageCopy.event_data ?? {};

    // TODO/HACK: workaround for MV-755: remove v1 start_dates and end_dates
    //  backend breaks if old format is sent in
    //  remove workaround then backend has been fixed
    pageCopy.event_data.start_dates = [];
    pageCopy.event_data.end_dates = [];

    // pull all events up to root level, in v2 they are not displayed in the tree
    if (pageCopy.parent_id) {
      pageCopy.parent_id = null;
    }
  }

  if (pageCopy.published_at === '') {
    // Backendcrash if empty published_at is sent in
    delete pageCopy.published_at;
  }

  return pageCopy;
}
